const RoleType = {
    Admin: 1,
    IncidentReporter: 2,
    IncidentAreaRepresentative: 3,
    CaseAdministrator: 4,
    //IncidentsAdministrator: 4,
    ServiceProviderUser: 5,
    CaseManager: 6,
    AccisureRep: 7
};

export default RoleType;
